import { Outlet } from "react-router";

import CourseCreateRoute from "./routes/CourseCreateRoute";
import CourseEditRoute from "./routes/CourseEditRoute";
import CourseListRoute from "./routes/CourseListRoute";

export const courseRoutes = [
    {
        path: "courses",
        handle: { breadcrumb: "course:courseListScreen.title" },
        element: <Outlet />,
        children: [
            { index: true, element: <CourseListRoute /> },
            {
                path: "new",
                handle: { breadcrumb: "course:courseCreateScreen.title" },
                element: <CourseCreateRoute />,
            },
            {
                path: ":courseId",
                handle: { breadcrumb: "course:courseEditScreen.title" },
                element: <CourseEditRoute />,
            },
        ],
    },
];
